import React, { useEffect, useState } from "react";
import ReservaFila from "./ReservaFila";
import { ToastContainer } from "react-toastify";
import ModalFactura from "./ModalFactura";
import { toolsAPI } from "../../../utils/funcionesAPI";
import { manejadorDeRespuesta, traerModalidadTarjeta } from "../../../utils/Tools";
import { toast } from "react-toastify";
import ModalLinkPago from "./ModalLinkPago";

const ListadoReservas = (props) => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarModalLinkPago, setMostrarModalLinkPago] = useState(false);
  const [modalidadTarjeta, setModalidadTarjeta] = useState('prisma');
  const [reservaSeleccionada, setReservaSeleccionada] = useState(0);

  useEffect(() => {
    traerModalidadTarjeta(setModalidadTarjeta);
  }, []);

  const handleSolicitarFacturaClick = (esPropia, numeroReserva) => {
    /*if (esPropia) {
            const formulario = { responsabilidad: "", tipoDocumento:{sigla: ''},
                                    numeroDocumento: '', factura: "", razonSocial: '',
                                    direccion: '', numeroReserva: numeroReserva, esPropia: 1}

            let data = JSON.stringify({accion: 'solicitarFactura', formulario: formulario});
            toolsAPI(data)
            .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta)){
                   toast.success(respuesta.data, {
                    position: toast.POSITION.BOTTOM_CENTER
                  });
                  this.props.onClickBotonFactura();
              }

            });

        } else {*/

    setMostrarModal(true);
    setReservaSeleccionada(numeroReserva);
  };

  const handleGenerarLinkDePago = (reserv) => {

    setMostrarModalLinkPago(true);
    setReservaSeleccionada(reserv);
  };

  const handleBorrarSolicitudDeFactura = (numeroReserva) => {
    const datos = JSON.stringify({
      accion: "eliminarFacturaSolicitada",
      numeroReserva: numeroReserva,
    });
    toolsAPI(datos).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        props.onClickBotonFactura();
      }
    });
  };

  const handleCancelarModalClick = () => {
    setMostrarModal(false);
  };

  const handleCancelarModalLinkPagoClick = () => {
    setMostrarModalLinkPago(false);
  };

  const handleClickBotonFactura = () => {
    props.onClickBotonFactura();
  };

  const reservas = props.reservas;

  return (
    <div
      id="mainMisReservas"
      className="main col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <div className="container-fluid">
        <div className="show-results">
          {reservas.length === 0 && <p className="resultados">No hay Reservas disponibles</p>}
          {reservas.map((reserva) => {
            return (
              <ReservaFila
                key={reserva.numeroReserva}
                reserva={reserva}
                onSolicitarFacturaClick={handleSolicitarFacturaClick}
                onGenerarLinkDePago={handleGenerarLinkDePago}
                onBorrarSolicitudDeFactura={handleBorrarSolicitudDeFactura}
                modalidadTarjeta={modalidadTarjeta}
              />
            );
          })}

          <ToastContainer />
          {/*---MOSTRAR MODAL  ---*/}
          {mostrarModal && (
            <ModalFactura
              numeroReserva={reservaSeleccionada}
              onCancelarClick={handleCancelarModalClick}
              onClickBotonFactura={handleClickBotonFactura}
            />
          )}
          {mostrarModalLinkPago && (
            <ModalLinkPago
              reserva={reservaSeleccionada}
              onCancelarClick={handleCancelarModalLinkPagoClick}
              //onClickBotonFactura={handleClickBotonFactura}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ListadoReservas;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/index.js